import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

const SECTION_STEPS_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/SectionStepsVector.svg';

const TITLE_TO_SUBTITLE_GAP = 16;
const SUBTITLE_TO_CARDS_GAP = 40;
const MOBILE_CARD_GAP = 32;

const SectionStepsIconMobileComponent = ({ data }) => {
  if (!data) return null;

  const { title, subtitle, steps = [] } = data;

  return (
    <Box
      sx={{
        display: { xs: 'block', md: 'none' },
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          backgroundColor: '#C7CA00',
          borderRadius: '28px',
          px: '20px',
          py: '32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          overflow: 'visible',
        }}
      >
        <ScrollFadeWrapper variant="text">
          <Typography
            component="h3"
            sx={{
              mt: `${TITLE_TO_SUBTITLE_GAP}px`,
              textAlign: 'center',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '2rem',
              lineHeight: '2.375rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              whiteSpace: 'pre-line',
            }}
          >
            {title}
          </Typography>
        </ScrollFadeWrapper>

        {subtitle && (
          <ScrollFadeWrapper variant="text" delay={0.2}>
            <Typography
              component="p"
              sx={{
                mt: 1,
                textAlign: 'center',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1.125rem',
                lineHeight: '1.5rem',
                letterSpacing: '-0.03em',
                color: '#162F3B',
                maxWidth: 520,
                mx: 'auto',
                whiteSpace: 'pre-line',
              }}
            >
              {subtitle}
            </Typography>
          </ScrollFadeWrapper>
        )}

        <Box
          sx={{
            mt: `${SUBTITLE_TO_CARDS_GAP}px`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${MOBILE_CARD_GAP}px`,
            width: '100%',
          }}
        >
          {steps.map((step, index) => (
            <ScrollFadeWrapper key={index} delay={0.4 + index * 0.15}>
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  maxWidth: '480px',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '24px',
                  pt: '72px',
                  px: '20px',
                  pb: '24px',
                  boxShadow:
                    '0px 1px 2px rgba(162,172,177,0.20), 0px 12px 24px -4px rgba(22,47,59,0.12)',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '-16px',
                    left: '14px',
                    width: '72px',
                    height: '72px',
                    zIndex: 2,
                  }}
                >
                  <Image
                    width={72}
                    height={72}
                    src={SECTION_STEPS_VECTOR_URL}
                    alt="Steps process graphic"
                    sx={{ width: '100%', height: '100%' }}
                  />

                  <Image
                    width={36}
                    height={36}
                    src={step.icon}
                    alt={step.imgAltTag || step.heading}
                    title={step.imageAltTitle || step.heading}
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '36px',
                      height: '36px',
                      objectFit: 'contain',
                      filter: 'brightness(0) invert(1)',
                    }}
                  />
                </Box>

                <Typography
                  component="h3"
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 700,
                    fontSize: '1.375rem',
                    lineHeight: '1.75rem',
                    color: '#162F3B',
                    mb: '12px',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {step.heading}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 400,
                    fontSize: '0.9375rem',
                    lineHeight: '1.5rem',
                    color: '#162F3B',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {step.text}
                </Typography>
              </Box>
            </ScrollFadeWrapper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SectionStepsIconMobileComponent;
